import { APP_ILGS_PARAMS } from '@common/constants';
import { reactLocalStorage } from 'reactjs-localstorage';

export interface IIlgsParams {
  ilgs_cid: string;
  ilgs_lid: string;
}

export function readIlgsParams(searchParams: URLSearchParams): IIlgsParams | null {
  const cid = (searchParams.get('ilgs_cid') ?? '').trim();
  const lid = (searchParams.get('ilgs_lid') ?? '').trim();
  return cid && lid ? { ilgs_cid: cid, ilgs_lid: lid } : null;
}

export function storeIlgsParams(searchParams: URLSearchParams): void {
  const params = readIlgsParams(searchParams);
  if (params) {
    reactLocalStorage.setObject(APP_ILGS_PARAMS, params);
  }
}

export function getIlgsParams(): IIlgsParams | null {
  const stored = reactLocalStorage.getObject(APP_ILGS_PARAMS, {}) as Partial<IIlgsParams>;
  if (!stored || !stored.ilgs_cid || !stored.ilgs_lid) {
    return null;
  }
  return { ilgs_cid: String(stored.ilgs_cid), ilgs_lid: String(stored.ilgs_lid) };
}

export function withIlgs<T extends object>(body: T): T & Partial<IIlgsParams> {
  const params = getIlgsParams();
  return params ? { ...body, ...params } : body;
}
